"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var input_option_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/input_option_store"));
var nested_single_select_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/nested_single_select_input_store"));
var nested_single_select_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/nested_single_select_input"));
var NestedSingleSelectOptionStore = /** @class */ (function (_super) {
    __extends(NestedSingleSelectOptionStore, _super);
    function NestedSingleSelectOptionStore(props) {
        var _this = _super.call(this, props) || this;
        _this.component = nested_single_select_input_1.default;
        if (props.options && props.selectProps) {
            _this.nestedSelectInputStore = new nested_single_select_input_store_1.default(__assign(__assign({}, props.selectProps), { options: props.options }));
        }
        return _this;
    }
    return NestedSingleSelectOptionStore;
}(input_option_store_1.default));
exports.default = NestedSingleSelectOptionStore;
